import Vue from 'vue';
import Vuex, { Module, MutationTree, ActionTree, GetterTree } from 'vuex';

import { IDictionary } from '@/shared/models/interface/dictionary-model';
import { IFilterItem } from '../../models/filter-item-model';
import IFilterGroup from "../../models/filter-group-model";

import FilterMapper from '../../mappings/filter-mapper';
import IScopeLink from '../../models/scope-links-model';

Vue.use(Vuex);

class ScopeState {
    scopes: IDictionary<IFilterItem> = {}
    scopeList: string[] = []
    activeScopeItems: string[] = []
    scopeLinks: IScopeLink[] = []
}

const mutations: MutationTree<ScopeState> = {
    setScopeFilters(state: ScopeState, scopes: IFilterGroup) {
        state.scopes = FilterMapper.scopes(scopes)
        state.scopeList = Object.keys(state.scopes)
    },

    setScopeLinks(state: ScopeState, scopeLinks: IScopeLink[]) {
        state.scopeLinks = scopeLinks
    },

    init(state: ScopeState, { scopes, scopeLinks }) {
        if (scopes) {
            state.scopes = FilterMapper.scopes(scopes);
            state.scopeList = Object.keys(state.scopes);
        }

        state.scopeLinks = scopeLinks;
    },

    setActiveScope(state: ScopeState, codename: string) {
        let index: number = state.activeScopeItems.indexOf(codename);

        if (index > -1) {
            Vue.delete(state.activeScopeItems, index);
        } else {
            state.activeScopeItems.push(codename);
        }
    },

    resetActiveScopes(state: ScopeState) {
        state.activeScopeItems = [];
    },
}

const actions: ActionTree<ScopeState, any> = {
    removeActiveScope({ commit }, [codename]) {
        commit('setActiveScope', codename);
    }
}

const getters: GetterTree<ScopeState, any> = {
    activeScopes(state): IFilterItem[] {
        return state.activeScopeItems.map(x => state.scopes[x]) as IFilterItem[];
    },

    activeScopeCodenames(state, getters): string[] {
        return getters.activeScopes.map((x: IFilterItem) => x.CodeName);
    },

    scopeList(state): IFilterItem[] {
        return state.scopeList.map(x => state.scopes[x]);
    },

    scopeItem: (state) => (name: string) => {
        return Object.values(state.scopes).find((x: IFilterItem) => x.DisplayName == name)
    },

    filteredScopeLinks(state, getters): IScopeLink[] {
        if (!state.activeScopeItems.length || !state.scopeLinks) {
            return [];
        }

        let activeScopeCodenames = getters.activeScopes.map((x: IFilterItem) => x.CodeName);

        return state.scopeLinks.filter((scopeLink: IScopeLink) =>
            scopeLink.Scopes.some((scope: string) =>
                activeScopeCodenames.includes(scope)
            )
        );
    }
}

export const scopeStoreModule: Module<ScopeState, any> = {
    namespaced: true,
    state: new ScopeState,
    mutations: mutations,
    actions: actions,
    getters: getters,
}